import { render, staticRenderFns } from "./Game4-1.vue?vue&type=template&id=2e1455c7&scoped=true&"
import script from "./Game4-1.vue?vue&type=script&lang=js&"
export * from "./Game4-1.vue?vue&type=script&lang=js&"
import style0 from "./Game4-1.vue?vue&type=style&index=0&id=2e1455c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1455c7",
  null
  
)

export default component.exports